import { REACT_APP_API_URL } from "../../setup/config";
import axios, { handleApiError } from '../axios';

export const getBuyerPOs = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-po/`, data);
        return await response.data;
    } catch (error) {
        console.log("getBuyerPOsData - error", error)
        return handleApiError(error)
    }
}

export const searchBuyerPOsRaw = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-po/search`, data);
        return await response.data;
    } catch (error) {
        console.log("searchBuyerPOsRaw - error", error)
        return handleApiError(error)
    }
}

export const insertBuyerPO = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-po/create`, data);
        return await response.data;
    } catch (error) {
        console.log("insertBuyerPO - error", error)
        return handleApiError(error)
    }
}

export const updateBuyerPO = async (data) => {
    try {
        let { buyerPOId, buyerPO } = data
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-po/update/${buyerPOId}`, buyerPO);
        return await response.data;
    } catch (error) {
        console.log("updateBuyerPO - error", error)
        return handleApiError(error)
    }
}

export const getPODocDetailsUsingPOParser = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-po/parser/${data.buyerPOId}`, data);
        return await response.data;
    } catch (error) {
        console.log("getPODocDetailsByPOParser - error", error)
        return handleApiError(error)
    }
}

export const getBuyerPOByBuyerPOId = async (buyerPOId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/buyer-po/${buyerPOId}`);
        // console.log("ressssss", response)
        return response.data;
    } catch (error) {
        console.log("getBuyerPOByBuyerPOId - error", error)
        return handleApiError(error)
    }
}

export const insertPOPunch = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-po/update-buyer-po`, data);
        return await response.data;
    } catch (error) {
        console.log("poPunch - error", error)
        return handleApiError(error)
    }
}

export const getBuyerPOsByBuyerReqIds = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-po/all-buyer-po`, data);
        return await response.data;
    } catch (error) {
        console.log("getBuyerPOsByBuyerReqIds - error", error)
        return handleApiError(error)
    }
}

export const cancelBuyerPO = async (buyerPOId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-po/cancel-buyer-po/${buyerPOId}`, data);
        return await response.data;
    } catch (error) {
        console.log("cancelBuyerPO - error", error)
        return handleApiError(error)
    }
}

export const getBuyerPOByBuyerQuoteId = async (buyerQuoteId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/buyer-po/get-buyer-po/${buyerQuoteId}`);
        return await response.data;
    } catch (error) {
        console.log("getBuyerPOByBuyerQuoteId - error", error)
        return handleApiError(error)
    }
}

export const getActiveBuyerPOByBuyerQuoteId = async (buyerQuoteId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/buyer-po/active-buyer-po/${buyerQuoteId}`);
        return await response.data;
    } catch (error) {
        console.log("getActiveBuyerPOByBuyerQuoteId - error", error)
        return handleApiError(error)
    }
}

export const forceCloseBuyerPO = async (buyerPOId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-po/force-close-buyer-po/${buyerPOId}`, data);
        return await response.data;
    } catch (error) {
        console.log("forceCloseBuyerPO - error", error)
        return handleApiError(error)
    }
}
export const getBuyerPOByDocNo = async (docNo) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/buyer-po/get-buyer-po-by-doc-no/${docNo}`);
        return await response.data;
    } catch (error) {
        console.log("getBuyerPOByDocNo - error", error)
        return handleApiError(error)
    }
}

export const getBuyerPOsByMaterialIds = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-po/material-ids`, data);
        return await response.data;
    } catch (error) {
        console.log("getBuyerPOsByMaterialIds - error", error)
        return handleApiError(error)
    }
}

export const getBuyerPOsByDispatchNoteIds = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-po/dispatch-note-ids`, data);
        return await response.data;
    } catch (error) {
        console.log("getBuyerPOsByDispatchNoteIds - error", error)
        return handleApiError(error)
    }
}
